import { useEffect, useRef, useState, type ReactNode } from "react";
import {
  QueryClient,
  QueryClientProvider,
  useQueryClient,
} from "@tanstack/react-query";

// Key this provider by user and workspace. Legacy domain query keys then remain
// private to their authenticated workspace, including before the shell reloads.
export function WorkspaceQueryProvider({ children }: { children: ReactNode }) {
  const inherited = useQueryClient();
  const [client] = useState(
    () => new QueryClient({ defaultOptions: inherited.getDefaultOptions() }),
  );
  const active = useRef(false);
  useEffect(() => {
    active.current = true;
    return () => {
      active.current = false;
      // StrictMode replays effects on the same instance. Dispose only when
      // that instance stays unmounted, so replay does not duplicate reads.
      queueMicrotask(() => {
        if (!active.current) {
          void client.cancelQueries();
          client.clear();
        }
      });
    };
  }, [client]);
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
